import { CargoIntegrationResult } from "../cargo-integration";
import { CustomerAddressResult } from "../customer-address";
import { CustomerEmployeeFullResult } from "../customer-employee";
import { ERPResult } from "../erp";
import { ModuleResult } from "../module";
import { ProjectResult } from "../project";
import { VirtualPosResult } from "../virtual-pos";

export class CustomerFullResult {
    public id: number;
    public code: string;
    public name: string;
    public customerRepresentative: number;
    public taxNumber: string;
    public taxAdministration: string;
    public logoFileName = '';
    public isDeleted: boolean;
    public employees: Array<CustomerEmployeeFullResult>;
    public projects: Array<ProjectResult>;
    public customerAddresses: Array<CustomerAddressResult>;
    public cargoIntegrations: Array<CargoIntegrationResult> = [];
    public erPs: Array<ERPResult> = [];
    public modules: Array<ModuleResult> = [];
    public virtualPoses: Array<VirtualPosResult> = [];

    // front-end
    public logoFile: Uint8Array | null = null;
    public employeeIsInvalid: boolean;
    public projectsIsInvalid: boolean;
    public customerTypeEnumIsInvalid: boolean;
    public taxNumberIsInvalid: boolean;
    public taxAdministrationIsInvalid: boolean;
    public nameIsInvalid: boolean;
    public addressIsInvalid: boolean;
    public customerContactIsInvalid: boolean;

    constructor() {
        this.employeeIsInvalid = true;
        this.projectsIsInvalid = true;
        this.customerTypeEnumIsInvalid = true;
        this.taxNumberIsInvalid = true;
        this.taxAdministrationIsInvalid = true;
        this.nameIsInvalid = true;
        this.addressIsInvalid = true;
        this.customerContactIsInvalid = true;
        this.id = 0;
        this.code = '';
        this.name = '';
        this.customerRepresentative = 0;
        this.taxNumber = '';
        this.taxAdministration = '';
        this.isDeleted = false;
        this.employees = new Array<CustomerEmployeeFullResult>();
        this.projects = new Array<ProjectResult>();
        this.customerAddresses = new Array<CustomerAddressResult>();
    }
}
